
































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { IUserRegistration, IValidations, IForm } from '@/interfaces';
import { UserRegistrationValidator } from '@/validators';
import { FormMixinComponent } from '@/mixins';

import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';
import Btn from '@/components/Btn.vue';
import Splitter from '@/components/Splitter.vue';

@Component({
  name: 'parent-registration-form',
  components: { Field, TextField, Btn, Splitter },
  mixins: [ FormMixinComponent ]
})
export default class ParentRegistrationFormComponent extends Vue implements IForm<IUserRegistration> {
  /**
   * To determine if this form is loading or not
   */
  @Prop({ type: Boolean, default: false }) public loading!: boolean;

  /**
   * The saved validations so we can show them if needed
   */
  public validations: IValidations<IUserRegistration> | null = null;

  /**
   * The validator we should use when checking validations
   */
  public validator = new UserRegistrationValidator();

  /**
   * The user we are creating
   */
  public model: IUserRegistration = {
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: ''
  }
}
